import RewardLedgerView from "./RewardLedgerView";
import { fetchRewardLedgerPending } from "../../store/loyaltySlices/rewardLedgerSlice";

export default function RewardLedgerPending() {
    return (
        <RewardLedgerView
            title="Reward Ledger Pending"
            subtitle="Reward entries that are still awaiting confirmation."
            stateKey="pending"
            fetchAction={fetchRewardLedgerPending}
            emptyText="No pending ledger entries"
        />
    );
}